import React, { useState } from "react";

const faqs = [
  {
    question: "What is ZeedBio?",
    answer:
      "ZeedBio is a simple platform that lets you create one beautiful page containing all your important links, social media profiles, websites, stores and content. Share one link everywhere."
  },
  {
    question: "How do I create my ZeedBio page?",
    answer:
      "Create an account, choose your ZeedBio username, add your links, customize your profile and design, then share your unique link with your audience."
  },
  {
    question: "Can I add social media links?",
    answer:
      "Yes. You can add links to Instagram, TikTok, Facebook, YouTube, WhatsApp, LinkedIn, X and any other website or platform you use."
  },
  {
    question: "Can I customize my ZeedBio page?",
    answer:
      "Yes. You can personalize your ZeedBio page with your profile image, name, bio, links and other design options to match your personal or business identity."
  },
  {
    question: "Can I use ZeedBio for my business?",
    answer:
      "Absolutely. ZeedBio is designed for creators, influencers, businesses, brands, artists, freelancers and professionals who want to share everything through one simple link."
  },
  {
    question: "Can I update my links later?",
    answer:
      "Yes. You can log in to your ZeedBio dashboard anytime to add, edit, delete or reorganize your links. Your ZeedBio URL stays the same."
  },
  {
    question: "Where can I share my ZeedBio link?",
    answer:
      "You can share your ZeedBio link in your Instagram bio, TikTok profile, Facebook page, YouTube channel, WhatsApp, email signature, website and anywhere else online."
  },
  {
    question: "Is ZeedBio easy to use?",
    answer:
      "Yes. ZeedBio is built to be simple and easy to manage. You do not need coding or technical skills to create and update your page."
  }
];

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(0);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section
      id="faq"
      className="bg-white py-16 dark:bg-gray-900 lg:py-24"
    >
      <div className="mx-auto max-w-screen-xl px-4 lg:px-6">
        
        {/* Heading */}
        <div className="mb-10 text-center lg:mb-14">
          <p className="mb-3 text-sm font-semibold uppercase tracking-wider text-purple-600 dark:text-purple-400">
            Help Center
          </p>

          <h2 className="mb-4 text-3xl font-extrabold tracking-tight text-gray-900 lg:text-4xl dark:text-white">
            Frequently asked questions
          </h2>

          <p className="mx-auto max-w-2xl text-gray-500 dark:text-gray-400">
            Everything you need to know about creating and sharing your
            ZeedBio link.
          </p>
        </div>

        {/* FAQ List */}
        <div className="mx-auto max-w-3xl">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="border-b border-gray-200 dark:border-gray-700"
            >
              <button
                type="button"
                onClick={() => toggleFAQ(index)}
                className="flex w-full items-center justify-between py-5 text-left font-medium text-gray-900 transition hover:text-purple-600 dark:text-white dark:hover:text-purple-400"
                aria-expanded={openIndex === index}
              >
                <span className="pr-6 text-base md:text-lg">
                  {faq.question}
                </span>

                <svg
                  className={`h-5 w-5 flex-shrink-0 transition-transform duration-300 ${
                    openIndex === index ? "rotate-180" : ""
                  }`}
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                    clipRule="evenodd"
                  />
                </svg>
              </button>

              {/* Answer */}
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index
                    ? "max-h-96 pb-5 opacity-100"
                    : "max-h-0 opacity-0"
                }`}
              >
                <p className="pr-10 leading-relaxed text-gray-500 dark:text-gray-400">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="mt-12 text-center">
          <p className="mb-4 text-gray-500 dark:text-gray-400">
            Still have questions?
          </p>

          <a
            href="mailto:contact.zeedcom@gmail.com"
            className="inline-flex items-center rounded-lg bg-purple-600 px-5 py-3 text-sm font-medium text-white transition hover:bg-purple-700 focus:outline-none focus:ring-4 focus:ring-purple-300 dark:bg-purple-600 dark:hover:bg-purple-700"
          >
            Contact ZeedBio Support

            <svg
              className="ml-2 h-5 w-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M13 7l5 5m0 0l-5 5m5-5H6"
              />
            </svg>
          </a>
        </div>
      </div>
    </section>
  );
};

export default FAQ;